<template>
  <div>
    <generic-modal
      :height="OrderDetailsModalDim.height"
      :width="OrderDetailsModalDim.width"
      :padding="OrderDetailsModalDim.padding"
      :modalClass="OrderDetailsModalDim.modalClass"
      overflowNotNeeded="true"
      contentScroll="1"
      v-if="!isOrderFailed && !isAdvancedOrderDetailPage"
    >
      <template v-slot:header>
        <div class="sticky-top">
          <div
            class="plr16 pt16 pb16 d-flex align-items-center"
            :class="[
              clientPlatform == 'Web' ? 'container-desktop' : 'border-bottom',
            ]"
          >
            <i class="hkfi-back fs-14 mr15 hand" @click="handleBackClick"></i>
            <div class="header-order-details">
              <span class="fs-14 bold lh24">Order Status</span>
              <span class="header-help" @click="handleHelpCTA">Help</span>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:body>
        <div
          :class="[
            clientPlatform == 'Web'
              ? 'container-desktop track-map-desktop'
              : '',
          ]"
          v-if="isOrderSuccessful"
        >
          <div class="tm-content">
            <div
              class="tm-lft"
              v-if="
                (mapUrl?.length > 0 && isOrderTypeDelivery) ||
                (isMapCordinatesAvailable && isOrderTypeDelivery)
              "
            >
              <navigation-map
                v-if="mapUrl?.length > 0 && isOrderTypeDelivery"
                :mapUrl="mapUrl"
              />
              <map-component
                v-else-if="isMapCordinatesAvailable && isOrderTypeDelivery"
                :initializeMapFeatures="initializeMapFeatures"
                :mapClassName="MapComponentDim.className"
                :disableGestureHandling="true"
              ></map-component>
            </div>
            <div class="tm-rgt">
              <!-- <delivery-agent-details
                v-if="isOrderTypeDelivery"
                @callEvent="handleCallEvent"
              ></delivery-agent-details> -->
              <order-status-timeline
                :active-index="statusIndex"
                :is-order-succesful="isOrderSuccessful"
              ></order-status-timeline>
              <order-price-card class="pt16 plr16"></order-price-card>

              <!-- @todo: not implementing in phase 1 -->
              <!-- <download-bill
                :src="'order-details'"
                @handleDownloadBill="handleDownloadBill"
              >
              </download-bill> -->
            </div>
          </div>
        </div>
        <div
          v-else-if="!isLoading"
          :class="[clientPlatform == 'Web' ? 'dt-mw-670' : '']"
        >
          <div>
            <!-- <div class="big-logo-wrap">
              <i class="hkfi-logo-hongs"></i>
            </div> -->
            <order-status-timeline
              :active-index="statusIndex"
              :is-order-succesful="false"
            ></order-status-timeline>
            <order-price-card class="pt16 plr16 pb16"></order-price-card>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <!-- <div
          class="footer-order-details"
          :class="[clientPlatform == 'Web' ? 'tc' : '']"
        >
          <p
            class="plr16 fs-12 footer-order-details-text"
            v-if="isOrderSuccessful"
          >
            Applicable terms and conditions text will be coming here with
            disclaimer conditions like, Not applicable for bulk and timed order.
            Refer detailed T&C.
          </p>
          <p class="plr16 fs-12 footer-order-details-text" v-else>
            If any amount deducted, it will be refunded in 7-10 working days.
            Please Retry
          </p>
        </div> -->
        <div class="bottom-nav-focused plr16" v-if="!isOrderSuccessful">
          <div
            class="btn bold custm-cta-full secondary"
            v-on:click="retryCtaHandler"
          >
            <span class="fs-14">Retry</span>
          </div>
        </div>
      </template>
    </generic-modal>
    <advance-order-details v-else-if="!isOrderFailed"></advance-order-details>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
import GenericModal from "./GenericModal.vue";
import { keyMapsAction, keyMapsMutation } from "../helpers/storeKeys";
import { OrderHistoryPages } from "../helpers/orderHistoryConstants";
import MapComponent from "./MapComponent.vue";
import MapUtils from "./../helpers/mapUtils";
import { staticImgBaseUrl, clientPlatform } from "../config/apiEndpoints";
import Utility from "../helpers/utility";
import NavigationMap from "./NavigationMap.vue";
import LocalStorageFunc from "../helpers/localStorageFunc";
import OrderStatusTimelineData from "../assets/FallbackData/OrderStatusTimelineData.json";
import { ORDER_TYPE } from "../helpers/OrderStatusConstants";
import { OrderTypesFromCode } from "../helpers/orderTypesConstants";
import {
  EVENT_CLICK_CALL_TRACK_ORDER,
  EVENT_CLICK_DOWNLOAD_BILL_TRACK_ORDER,
  EVENT_CLICK_HELP_TRACK_ORDER,
  EVENT_IMPRESSION_TRACKORDER,
  EVENT_CLICK_CART_EXPLOREMENU,
  EVENT_CLICK_REORDER,
} from "../helpers/analyticsEvents";

export default {
  name: "OrderDetails",
  components: {
    GenericModal,
    MapComponent,
    NavigationMap,
    DeliveryAgentDetails: defineAsyncComponent(() =>
      import("./DeliveryAgentDetails.vue")
    ),
    OrderStatusTimeline: defineAsyncComponent(() =>
      import("./OrderStatusTimeline.vue")
    ),
    OrderPriceCard: defineAsyncComponent(() => import("./OrderPriceCard.vue")),
    DownloadBill: defineAsyncComponent(() => import("./DownloadBill.vue")),
    AdvanceOrderDetails: defineAsyncComponent(() =>
      import("./AdvanceOrderDetails.vue")
    ),
  },
  props: {},
  data() {
    return {
      clientPlatform,
      OrderDetailsModalDim: {
        width: "100vw",
        height: "100vh",
        padding: "0px",
        modalClass: "full-screen-popup order-tracking-modal",
      },
      MapComponentDim: {
        className: "order-details-map",
      },
      staticImgBaseUrl,
      timelineStatusIndex: 2,
    };
  },
  mounted() {
    this.$store.dispatch(
      keyMapsAction.GET_ORDER_DETAILS_DATA,
      LocalStorageFunc.getOrderId()
    );
    this.$store.commit(keyMapsMutation.UPDATE_LOADING_STATE, true);
    let queryParams = Utility.getQueryFromUrl();
    if (queryParams["transactionId"]) {
      setTimeout(
        () =>
          this.$store.dispatch(keyMapsAction.POST_SUBMIT_TRACK_ORDER, {
            transactionId: queryParams["transactionId"],
          }),
        2000
      );
      window.history.pushState(
        "",
        "",
        window.location.href.split("?transactionId")[0]
      );
    } else {
      let selectedOrderSummary =
        this.$store.state.OrderTracking.trackOrder.orderSummary;
      if (Object.keys(selectedOrderSummary?.store).length) {
        this.$store.dispatch(keyMapsAction.GET_TRACK_ORDER_API, {
          mobile:
            selectedOrderSummary?.deliveryPhoneNumber ||
            LocalStorageFunc.getMobileNumber(),
          order: selectedOrderSummary?.store?.orderId,
        });
      } else if (LocalStorageFunc.getOrderSummary()) {
        let orderSummary = LocalStorageFunc.getOrderSummary();
        this.$store.dispatch(keyMapsAction.GET_TRACK_ORDER_API, {
          mobile:
            orderSummary?.deliveryPhoneNumber ||
            LocalStorageFunc.getMobileNumber(),
          order: orderSummary?.store?.orderId,
        });
      }
    }
    EVENT_IMPRESSION_TRACKORDER({
      category:
        "Order Status - " + this.getTimelineStatus(this.timelineStatusIndex),
    });
  },
  methods: {
    initializeMapFeatures(map, mapRef) {
      // @todo change logo according to address type selected
      // @todo change delivery and store data from order Detail API data
      let localOrderSummary = LocalStorageFunc.getOrderSummary();
      let deliveryLoc = {
        lat:
          this.$store.state.OrderTracking.trackOrder.orderSummary
            ?.deliveryAddress.latitude ||
          localOrderSummary.deliveryAddress.latitude,
        lng:
          this.$store.state.OrderTracking.trackOrder.orderSummary
            ?.deliveryAddress.longitude ||
          localOrderSummary.deliveryAddress.longitude,
      };
      let storeLoc = {
        lat:
          this.$store.state.OrderTracking.trackOrder.orderSummary?.store
            .latitude || localOrderSummary.store.latitude,
        lng:
          this.$store.state.OrderTracking.trackOrder.orderSummary?.store
            .longitude || localOrderSummary.store.longitude,
      };
      const posImage = {
        url: staticImgBaseUrl + "/images/global/curLocLogo.svg",
        scaledSize: new google.maps.Size(52, 52),
        anchor: new google.maps.Point(20, 20),
      };
      const markerView = MapUtils.addMarker({
        map: map,
        position: deliveryLoc,
        icon: posImage,
      });
      const markerImage = {
        url: staticImgBaseUrl + "/images/global/LogoMarker.svg",
        scaledSize: new google.maps.Size(52, 52),
        anchor: new google.maps.Point(40, 20),
      };

      let marker = MapUtils.addMarker({
        // store location
        position: storeLoc,
        map: map,
        icon: markerImage,
      });
      // showCurvedPath after the map has been projected
      google.maps.event.addListener(map, "projection_changed", () => {
        MapUtils.showCurvedPath({
          origin: storeLoc,
          destination: deliveryLoc,
          map: map,
        });
      });
    },
    handleBackClick(e) {
      if (LocalStorageFunc.getPrevUrl().includes("/order-history")) {
        Utility.redirectToOrderHistoryOrRedirectUrl();
      } else {
        Utility.redirectToHomeOrRedirectUrl();
      }
    },
    retryCtaHandler(event) {
      let order = this.orderSummary;
      event.preventDefault();
      EVENT_CLICK_REORDER({
        category: "Retry Clicked",
      });
      this.addToCartOnReorder(order?.items);
      Utility.sendToCartScreen();
    },
    addToCartOnReorder(items = []) {
      let reorderedItems = LocalStorageFunc.getReorderedItems();
      reorderedItems = [...reorderedItems, ...items];
      LocalStorageFunc.setReorderItemsOrder(reorderedItems);
    },
    getTimelineStatus(index) {
      let statusText = "";
      OrderStatusTimelineData?.data.map((status) => {
        if (status?.id == index) {
          statusText = status?.text;
        }
      });
      return statusText;
    },
    handleCallEvent() {
      EVENT_CLICK_CALL_TRACK_ORDER({
        subcategory: this.getTimelineStatus(this.timelineStatusIndex),
      });
    },
    handleHelpCTA() {
      Utility.sendToHelpPage();
      EVENT_CLICK_HELP_TRACK_ORDER({
        subcategory: this.getTimelineStatus(this.timelineStatusIndex),
        orderType: OrderTypesFromCode[this.deliveryTypeCode],
        orderStatus:
          this.$store.state.OrderTracking.trackOrder?.orderSummary
            ?.orderStatus || LocalStorageFunc.getOrderSummary()?.orderStatus,
      });
    },
    handleDownloadBill() {
      EVENT_CLICK_DOWNLOAD_BILL_TRACK_ORDER({
        subcategory: this.getTimelineStatus(this.timelineStatusIndex),
      });
    },
    handleExploreMenu() {
      EVENT_CLICK_CART_EXPLOREMENU();
      Utility.redirectToHomeOrRedirectUrl();
    },
  },
  computed: {
    // isOrderDetailPage() {
    //   return (
    //     LocalStorageFunc.getOrderHistoryPage() == OrderHistoryPages.ORDER_DETAIL
    //   );
    // },
    mapUrl() {
      return this.$store.state.OrderTracking.trackOrder.mapUrl;
    },
    statusIndex() {
      let localOrderSummary = this.orderSummary;
      let tracker = this.$store.state.OrderTracking.trackOrder?.tracker;
      this.timelineStatusIndex =
        tracker?.stage || localOrderSummary?.orderCurrentState;
      return this.timelineStatusIndex;
    },
    isMapCordinatesAvailable() {
      let localOrderSummary = this.orderSummary;
      return (
        (this.$store.state.OrderTracking.trackOrder.orderSummary?.store
          ?.latitude ||
          localOrderSummary?.store?.latitude) &&
        (this.$store.state.OrderTracking.trackOrder.orderSummary
          ?.deliveryAddress?.latitude ||
          localOrderSummary?.deliveryAddress?.latitude)
      );
    },
    isOrderTypeDelivery() {
      let localOrderSummary = this.orderSummary;
      let deliveryTypeCode =
        this.$store.state.OrderTracking.trackOrder.orderSummary
          ?.deliveryOrderType?.deliveryTypeCode ||
        localOrderSummary?.deliveryOrderType?.deliveryTypeCode;
      return deliveryTypeCode === ORDER_TYPE.DELIVERY;
    },
    isOrderSuccessful() {
      return this.$store.state.OrderTracking.isOrderSuccessful;
    },
    isLoading() {
      return this.$store.state.Loader.isLoading;
    },
    orderSummary() {
      let orderSummary =
        this.$store.state.OrderTracking.trackOrder.orderSummary;
      if (!orderSummary?.items) {
        return LocalStorageFunc.getOrderSummary();
      }
      return orderSummary;
    },
    isAdvancedOrderDetailPage() {
      return (
        LocalStorageFunc.getOrderHistoryPage() ==
        OrderHistoryPages.ADVANCED_ORDER_DETAIL
      );
    },
    isOrderFailed() {
      return this.$store.state.OrderTracking.isOrderFailed;
    },
  },
};
</script>
